import React from 'react';
import PublicKey from "./view/Payment/PublicKey";
import PublicKeyNetbee from "./view/Payment/PublicKeyNetbee";
import PosTest from "./view/Payment/PosTest";


export default function Payment() {
    return (
        <section className={"other-container print-container"}>
            <PosTest/>
            <PublicKey/>
            <PublicKeyNetbee/>
        </section>
    );
}